import { deliveryActionTypes } from '../actions/deliveryActions';

const initState = {
  deliveryGroups: [],
  deliveryGroupsLoaded: false,
  deliveryGroupsLoadFailed: false,
  // for legacy purpse only that if user search
  // the address through the url
  // Should have been replaced by city links
  searchOnlyDeliveryGroups: [],
  searchOnlydeliveryGroupsLoaded: false,
  searchOnlyDeliveryGroupsLoadFailed: false,

  restaurantCollection: [],

  suggestedMeals: [],
  suggestedMealsLoadFailed: false,
  suggestedMealsLoaded: false,
};

const DeliveryReducer = (state = initState, action) => {
  switch (action.type) {
    case deliveryActionTypes.searchRestaurantsStart:
    case deliveryActionTypes.fetchDeliveryGroupsStart:
      return {
        ...state,
        ...{
          deliveryGroupsLoaded: false,
          deliveryGroupsLoadedFailed: false,
        },
      };

    case deliveryActionTypes.searchRestaurantsSuccess:
      return {
        ...state,
        ...{
          deliveryGroups: action.deliveryGroups,
          deliveryGroupsLoaded: true,
          deliveryGroupsLoadedFailed: false,
          restaurantCollection: action.restaurantCollection,
        },
      };

    case deliveryActionTypes.fetchDeliveryGroupsSuccess:
      return {
        ...state,
        ...{
          deliveryGroups: action.deliveryGroups,
          deliveryGroupsLoaded: true,
          deliveryGroupsLoadedFailed: false,
        },
      };

    case deliveryActionTypes.searchRestaurantsFailed:
    case deliveryActionTypes.fetchDeliveryGroupsFailed:
      return {
        ...state,
        ...{
          deliveryGroupsLoaded: false,
          deliveryGroupsLoadedFailed: true,
        },
      };

    case deliveryActionTypes.searchRestaurantsByAddressStringStart:
      return {
        ...state,
        ...{
          searchOnlydeliveryGroupsLoaded: false,
          searchOnlyDeliveryGroupsLoadFailed: false,
        },
      };

    case deliveryActionTypes.searchRestaurantsByAddressStringSuccess:
      return {
        ...state,
        ...{
          searchOnlyDeliveryGroups: action.deliveryGroups,
          restaurantCollection: action.restaurantCollection,
          searchOnlydeliveryGroupsLoaded: true,
          searchOnlyDeliveryGroupsLoadFailed: false,
        },
      };

    case deliveryActionTypes.searchRestaurantsByAddressStringFailed:
      return {
        ...state,
        ...{
          searchOnlydeliveryGroupsLoaded: true,
          searchOnlyDeliveryGroupsLoadFailed: true,
        },
      };

    case deliveryActionTypes.searchOnTermStart:
      return {
        ...state,
        ...{
          suggestedMealsLoaded: false,
          suggestedMealsLoadFailed: false,
          suggestedMeals: [],
        },
      };

    case deliveryActionTypes.searchOnTermSuccess:
      return {
        ...state,
        ...{
          suggestedMealsLoaded: true,
          suggestedMealsLoadFailed: false,
          suggestedMeals: action.suggestedMeals,
        },
      };

    case deliveryActionTypes.searchOnTermFailed:
      return {
        ...state,
        ...{
          suggestedMealsLoaded: true,
          suggestedMealsLoadFailed: true,
          suggestedMeals: [],
        },
      };

    case deliveryActionTypes.fetchRestaurantCollectionSuccess:
      return {
        ...state,
        restaurantCollection: action.restaurantCollection,
      };

    default:
      return state;
  }
};

export default DeliveryReducer;
